import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user as userAPI, team } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "transparent",
    zIndex: 99,
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
};

function TeamConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openModalTeam, setOpenModalTeam] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [member, setMember] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [loading, setLoading] = useState(false);

  async function getUser() {
    try {
      const res = await userAPI.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          let tmp = [];
          data.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getTeam() {
    try {
      setLoading(true);
      const res = await team.list(query);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setTeams(data.results);
          setIsDirty(false);
        } else {
          setTeams([]);
          setIsDirty(false);
        }

        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getUser();
    getTeam();
  }, [query.page, query.take, isDirty]);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setSelectedRow(null);
    setOpenModalTeam(true);
    setTeamName("");
    setMember([]);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenModalTeam(true);
    setTeamName(value.team_name);
    setMember(
      value.members.map((member) => ({
        value: member.member.username,
        label: member.member.firstname + " " + member.member.lastname,
      }))
    );
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteUser() {
    try {
      const res = await team.delete(deleteRow.id);
      if (res.ok) {
        toast.success("This team has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
        await getTeam();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Team Name",
      selector: (row) => row.team_name,
    },
    {
      name: "Total Member",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.members?.length}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUser(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              onClick={() => {
                showConfirmationDlg(row);
              }}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    username,
    password,
    email,
    jobTitle,
    firstname,
    lastname,
    contactNumber,
    userRole,
    status,
  }) {
    let data = {
      username,
      password,
      email,
      job_title: jobTitle,
      firstname,
      lastname,
      //contact_number: contactNumber,
      role_id: userRole,
      //is_active: status == 1 ? true : false,
      is_staff: false,
    };
    if (!selectedRow) {
      const response = await userAPI.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User " + username + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await userAPI.update(selectedRow.username, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User " + username + " is successfully updated");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  async function onSubmitTeam() {
    const arr = member.map((i) => {
      return i.value;
    });
    let data = {
      team_name: teamName,
      members: arr,
    };
    console.log({ data });
    if (!selectedRow) {
      const response = await team.create2(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully added");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await team.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully updated");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <ConfirmationDlg
        open={openModalTeam}
        onSubmit={onSubmitTeam}
        btnSubmitText={"Save"}
        title={"Add Team"}
        btnCancelText={"Cancel"}
        onClose={() => {
          setOpenModalTeam(false);
        }}
      >
        <NormalInput
          required={true}
          value={teamName}
          type={"text"}
          label="Team Name"
          onchange={(e) => {
            setTeamName(e.target.value);
          }}
          name="teamName"
        />
        <div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>
          <label className="form-label">Member</label>
          <Select
            isMulti
            styles={colourStyles}
            options={users.map((i) => {
              return {
                value: i.username,
                label: i.firstname + " " + i.lastname,
              };
            })}
            value={member}
            onChange={(e) => {
              setMember(e);
            }}
          />
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this Team?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Team</li>
          </ol>
          <h1 className="page-header mb-0">Team</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <button onClick={addUser} className="btn btn-outline-theme w-100">
                Add Team <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Worker / People</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={teams}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default TeamConfiguration;
